module.exports = __webpack_public_path__ + "img/lbl-01.ef5bcdf0.png";